var map = {
	"./provider_1x2Gaming_logo.png": 43832,
	"./provider_Amatic_logo.png": 63736,
	"./provider_Apollo_logo.png": 37368,
	"./provider_Aristocrat_logo.png": 49359,
	"./provider_BB-games_logo.png": 44957,
	"./provider_Bet-games_logo.png": 1946,
	"./provider_Blueprint-Gaming_logo.png": 99190,
	"./provider_Booongo_logo.png": 88950,
	"./provider_Cq9_logo.png": 30984,
	"./provider_Dragon-soft_logo.png": 94409,
	"./provider_Ebet_color_logo.png": 53885,
	"./provider_Evolution_logo.png": 95706,
	"./provider_Evoplay_logo.png": 68707,
	"./provider_Ezugi_logo.png": 67872,
	"./provider_Fantasma-Games_logo.png": 79307,
	"./provider_Fugaso_logo.png": 25679,
	"./provider_Gamefish-Global_logo.png": 63251,
	"./provider_Gaminator_logo.png": 13634,
	"./provider_Gamzix_logo.png": 50208,
	"./provider_Greentube_logo.png": 55875,
	"./provider_Habanero_logo.png": 36396,
	"./provider_Hacksaw_logo.png": 23444,
	"./provider_IGT_logo.png": 4245,
	"./provider_Igrosoft_logo.png": 65318,
	"./provider_Iron-Dog_logo.png": 20662,
	"./provider_Kajot_logo.png": 78307,
	"./provider_Kalamba-Games_logo.png": 58749,
	"./provider_Kiron_logo.png": 68703,
	"./provider_Konami_logo.png": 96736,
	"./provider_Lady-Luck_logo.png": 20225,
	"./provider_Maverick_logo.png": 59821,
	"./provider_Merkur_logo.png": 73993,
	"./provider_Microgaming_logo.png": 39629,
	"./provider_Mobilots_logo.png": 27071,
	"./provider_Netent_logo.png": 79183,
	"./provider_Netgame_logo.png": 46881,
	"./provider_Nolimit-City_logo.png": 87050,
	"./provider_OMI-Gaming_logo.png": 27644,
	"./provider_OneTouch_logo.png": 13962,
	"./provider_Playngo_logo.png": 95119,
	"./provider_Playpearls_logo.png": 16594,
	"./provider_Playson_logo.png": 59008,
	"./provider_Pragmatic-Play_logo.png": 30365,
	"./provider_Pragmatic-play-live_logo.png": 72688,
	"./provider_Print-Studios_logo.png": 58870,
	"./provider_Push-Gaming_logo.png": 47489,
	"./provider_Quickspin_logo.png": 43427,
	"./provider_Red-Tiger_logo.png": 98755,
	"./provider_Relax-Gaming_logo.png": 96744,
	"./provider_Revolver-Gaming_logo.png": 33902,
	"./provider_Rtg-Slots_logo.png": 55992,
	"./provider_Skywind-Group_logo.png": 38585,
	"./provider_Skywind-life_logo.png": 56031,
	"./provider_Slotmill_logo.png": 46517,
	"./provider_Spearhead_logo.png": 13250,
	"./provider_Splitrock_logo.png": 62896,
	"./provider_Thunderkick_logo.png": 59195,
	"./provider_Tpg_logo.png": 81629,
	"./provider_Wazdan_logo.png": 44267,
	"./provider_Yggdrasil_logo.png": 30245,
	"./provider_august_gaming_logo.png": 40317,
	"./provider_austria_color_logo.png": 98337,
	"./provider_betradar_virtual_sports_logo.png": 22314,
	"./provider_betskilla_color_logo.png": 32579,
	"./provider_cqgaming_color_logo.png": 99639,
	"./provider_fishing_color_logo.png": 67312,
	"./provider_gameart_logo.png": 2899,
	"./provider_playtech_logo.png": 10335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5463;